import { render, staticRenderFns } from "./Betmode.vue?vue&type=template&id=99deee48&scoped=true"
import script from "./Betmode.vue?vue&type=script&lang=js"
export * from "./Betmode.vue?vue&type=script&lang=js"
import style0 from "./Betmode.vue?vue&type=style&index=0&id=99deee48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99deee48",
  null
  
)

export default component.exports